module.exports = __webpack_public_path__ + "img/Live-Cards.98741cf.webp";